module.exports = __webpack_public_path__ + "media/widget/drug_allergies-f6e986f2.png";